<template lang="pug">
.search-study
  pulldown-select.search-study__action(v-model='selectedYear', :selectOptions='yearSelectOptions')
  pulldown-select.search-study__action(v-model='selectedMonth', :selectOptions='monthSelectOptions')
  button-search.search-study__action(:data-disabled='disabled', @click='doSearch')
    slot(name='searchButtonText')
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import PulldownSelect from '@/components/molecules/manager/PulldownSelect.vue'
import ButtonSearch from '@/components/molecules/manager/ButtonSearch.vue'
import { InputItem } from '@/models/inputItem'

/**
 * テスト管理の絞り込み
 */
@Component({
  components: {
    PulldownSelect,
    ButtonSearch,
  },
})
export default class SearchStudy extends Vue {
  // 実施年度選択オプション
  @Prop()
  yearSelectOptions!: InputItem[]

  // 実施月選択オプション
  @Prop()
  monthSelectOptions!: InputItem[]

  // 実施年度選択値
  @Prop()
  yearValue!: string

  // 実施月選択値
  @Prop()
  monthValue!: string

  // 実施年度変更時イベント
  @Prop()
  yearChangeEvent!: Function

  // 実施月変更時イベント
  @Prop()
  monthChangeEvent!: Function

  // 検索ボタン押下時イベント
  @Prop()
  searchEvent!: Function

  /*
   * 入力値ゲッター・セッター
   */
  // 実施年度
  get selectedYear(): string {
    return this.yearValue
  }
  set selectedYear(value: string) {
    this.yearChangeEvent(value)
  }

  // 実施月
  get selectedMonth(): string {
    return this.monthValue
  }
  set selectedMonth(value: string) {
    this.monthChangeEvent(value)
  }

  // 実施年度、実施月は必須で未入力時は検索不可
  private get disabled(): boolean {
    return this.yearValue === '' || this.monthValue === ''
  }

  private doSearch() {
    if (this.disabled) return

    this.searchEvent()
  }
}
</script>

<style lang="stylus" scoped>
.search-study
  display flex

  &__action
    margin 7px 5px
</style>
